const INITIAL_STATE = { KPIsList: [], loading: true };
export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case "GET_KPIS": {
      return {
        ...state,
        KPIsList: payload,
        loading: false
      };
    }
    case "CLEARKPIS": {
      return {
        ...INITIAL_STATE
      };
    }

    default:
      return state;
  }
};
